import baseConfig from './config.base'

export default {
  ...baseConfig,
  debugAnalytics: false,
  qrCodeWidgetEnabled: false,
}
